import { useQuery } from '@tanstack/react-query';
import { workflowNotificationCount } from '../api/workflowNotifications';

export const WORKFLOW_NOTIFICATIONS_QUERY_KEY = ['workflow-notifications'];

/** Own notifications that haven't been hidden yet. */
export function useWorkflowNotificationCount() {
  const query = useQuery({
    queryKey: [...WORKFLOW_NOTIFICATIONS_QUERY_KEY, 'count'],
    queryFn: workflowNotificationCount,
    refetchInterval: 60_000,
  });
  return query.data ?? 0;
}
